import { useSelector } from "react-redux";
import {
  ProductName,
  ProductPrice,
  ProductBadges,
} from "../components/ProductsList";
import BestSellerBadge from "../components/BestSellerBadge";
import useGoTo from "../hooks/useGoTo";
import { getProductAvailability } from "../hooks/useWorkingTime";

export default function ProductsHighlights() {
  const goTo = useGoTo();
  const products = useSelector((state) => state.products.items);
  const isSearching = useSelector((state) => !!state.search.content.trim());
  const availableProducts = products.filter(
    (p) => p.isHighlight && getProductAvailability(p).isAvailable,
  );

  // durante a busca, os destaques só empurrariam o resultado para baixo
  if (!availableProducts.length || isSearching) {
    return null;
  }

  return (
    <section className="highlights" aria-labelledby="highlights-title">
      <h2 id="highlights-title" className="section-title">
        Destaques
      </h2>
      <ul className="highlights__track">
        {availableProducts.map((product) => (
          <li key={product.id}>
            <HighlightCard
              product={product}
              onClick={() => goTo(`/product/${product.id}`)}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}

function HighlightCard({ product, onClick }) {
  return (
    // div com role, e não <button>: o card tem título e parágrafos, que o
    // HTML não aceita dentro de um botão.
    <div
      className="highlight-card"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      {!!product.pictureUrl && (
        <div className="highlight-card__media">
          <img
            loading="lazy"
            decoding="async"
            src={product.pictureUrl}
            alt=""
            width="152"
            height="112"
          />
          {product.isBestSeller && <BestSellerBadge overlay />}
        </div>
      )}
      <div className="highlight-card__body">
        <ProductName product={product} />
        <ProductBadges product={product} />
        <ProductPrice product={product} />
      </div>
    </div>
  );
}
